import { render, staticRenderFns } from "./portfolio.vue?vue&type=template&id=7e811896&"
import script from "./portfolio.vue?vue&type=script&lang=js&"
export * from "./portfolio.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {BlogHero: require('/opt/buildhome/repo/components/sections/BlogHero.vue').default,DataIterator: require('/opt/buildhome/repo/components/data-iterator.vue').default})


/* vuetify-loader */
import installComponents from "!../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VContainer,VRow})
